import React, { useEffect, useState, useRef } from 'react';

const SponsorCarousel = ({ sponsors }) => {
  const [isHovered, setIsHovered] = useState(false);
  const scrollRef = useRef(null);

  // Double the sponsors for seamless infinite scroll
  const doubledSponsors = [...sponsors, ...sponsors];

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId;
    let scrollPosition = 0;
    const scrollSpeed = 0.5; // pixels per frame

    const animate = () => {
      if (!isHovered) {
        scrollPosition += scrollSpeed;
        
        // Reset scroll when we've scrolled through the first set
        const halfWidth = scrollContainer.scrollWidth / 2;
        if (scrollPosition >= halfWidth) {
          scrollPosition = 0;
        }
        
        scrollContainer.scrollLeft = scrollPosition;
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [isHovered]);

  return (
    <div 
      className="relative overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-blue-50 to-transparent z-10 pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-blue-50 to-transparent z-10 pointer-events-none"></div>
      
      <div 
        ref={scrollRef}
        className="flex gap-8 overflow-x-hidden py-4"
        style={{ scrollBehavior: 'auto' }}
      >
        {doubledSponsors.map((sponsor, index) => (
          <div 
            key={`${sponsor.id}-${index}`}
            className="flex-shrink-0 flex items-center justify-center p-4 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 min-w-[200px] h-[120px]"
          >
            <img 
              src={sponsor.logo} 
              alt={sponsor.name} 
              className="max-w-[180px] max-h-[100px] object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://via.placeholder.com/180x80/047857/ffffff?text=${encodeURIComponent(sponsor.name)}`;
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SponsorCarousel;
